import React from 'react'
import Banners from '../../Components/Banners/Banners'
import Products from '../../Components/Products/Products'
import './Demo.css'
import Footer from '../../Components/Footer/Footer'
import BtnWhatsapp from '../../Components/BtnWhatsapp/BtnWhatsapp'
import Cart from '../../Components/Cart/Cart'
import Developer from '../../Components/Developer/Developer'
import BannersMore from '../../Components/BannersMore/BannersMore'
export default function Demo() {
    return (
        <section className='demo'>
            <Banners />
            <BannersMore/>
            <Products />
            <Footer />
            <Developer />
            <BtnWhatsapp />
            <Cart />
        </section>
    )
}
